/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import { useAuth } from '../../../../../../../state/ducks/Member/ducks/Auth/Plugin/auth';

const styles = (theme) =>  ({
    mainContainer: {
        marginBottom: 10,
    },
    blockContentLinks: {
        display: 'flex',
        marginTop: 30,
        justifyContent: 'center',
        flexWrap: 'wrap',
        alignItems: 'center',
        flexDirection: 'column',
    },
    loginSocialBlock: {
        borderRadius: '2px',
        display: 'flex',
        padding: 10,
        marginBottom: 15,
        fontWeight: 600,
        textTransform: 'none',
        width: '100%',
        maxWidth: 230,
        cursor: 'pointer',
    },
    socialLoginImg: {
        width: '18.6px',
        height: '18.85px',
        margin: '0 9px',
        verticalAlign: 'sub',
    },
    signInWithGoogle: {
        color: theme.palette.common?.black || '#000',
        float: 'right',
        border: `1px solid ${theme.palette.common?.white || '#fff'}`,
        boxShadow: '0px 1.8px 7px -1px rgb(0,0,0,0.4)',
        backgroundColor: theme.palette.common?.white || '#fff',
    },
    signInWithFaceBook: {
        color: theme.palette.common?.white || '#fff',
        float: 'left',
    },
});

const DesktopAccountSocialLogin = ({ classes }) => {
    const { loginByRedirect } = useAuth();

    const signInWithFaceBook = async () => {
        await loginByRedirect({ connection: 'facebook' });
    };

    const signInWithGoogle = async () => {
        await loginByRedirect({ connection: 'google-oauth2' });
    };

    return (
        <>
            <div className={classes.blockContentLinks}>
                <div role="button" tabIndex="0" onKeyDown={() => {}} onClick={signInWithFaceBook} className={`signFaceBookIcon ${classes.signInWithFaceBook} ${classes.loginSocialBlock}`}>
                    <img className={classes.socialLoginImg} src="/static/images/fb_white.svg" alt="Facebook" />
                    <span className="component">Login with Facebook</span>
                </div>
                <div role="button" tabIndex="-1" onKeyDown={() => {}} onClick={signInWithGoogle} className={`${classes.signInWithGoogle} ${classes.loginSocialBlock}`}>
                    <img className={classes.socialLoginImg} src="/static/images/google.svg" alt="Google" />
                    <span className="component">Sign in with Google</span>
                </div>
            </div>
        </>
    );
};

DesktopAccountSocialLogin.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(DesktopAccountSocialLogin);
